module.exports = __webpack_public_path__ + "static/media/icons-ic-follow-up-demo-connected.937fcbe2.svg";